module.exports = __webpack_public_path__ + "static/media/epark-phone.f25430d0.svg";